import React from "react";
import { Route, Redirect, RouteProps } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { routes } from "../constants";

const PrivateRoute: React.FC<RouteProps> = ({ component, ...rest }) => {
  const isClientPortalUserAuthenticated = useSelector(
    (state: RootState) => state.isClientPortalUserAuthenticated
  );
  const { clientPortal } = routes;
  if (!isClientPortalUserAuthenticated) {
    return <Redirect to={`${clientPortal.name}/${clientPortal.subRoutes.login.name}`} />;
  }
  return <Route {...rest} component={component} />;
};

export default PrivateRoute;
